import { ProductsService } from '../services/ProductsService'

import { ProductsRoutingService } from '#Products/routing'

export const useProducts = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(ProductsService)
    },
    get routing() {
      return alt.get(ProductsRoutingService)
    },
  }
}
